import { createFeatureSelector, createSelector, createSelectorFactory } from '@ngrx/store';

import * as fromStore from '../reducers/pig.reducer';

const pigState = createFeatureSelector<fromStore.State>(fromStore.pigFeatureKey);

export const diameters = createSelector(pigState, state => (state || {}).diameters);
export const efficiencies = createSelector(pigState, state => (state || {}).efficiencies);
export const purposes = createSelector(pigState, state => (state || {}).purposes);
export const services = createSelector(pigState, state => (state || {}).services);

export const selectFilter = createSelector(pigState, state => (state || {}).pigQueryParams);
export const selectFilterResults = createSelector(pigState, state => (state || {}).pigQueryResults);
export const selectActivePurposeId = createSelector(selectFilter, filt => filt?.pigPurposeId);

export const selectActiveId = createSelector(pigState, state => state.activatedPigId);
export const selectActiveObj = createSelector(selectFilterResults, selectActiveId, (results, id) => results.find(f => f.productId === id));
export const selectActiveProductInfo = createSelector(pigState, state => state.activePigProductInfo);
export const selectActiveProductBypassInfo = createSelector(pigState, state => state.activePigBypassInfo);
export const selectActiveReplacementParts = createSelector(pigState, state => state.activePigReplacementParts);
export const selectActivePigComponents = createSelector(pigState, state => state.activePigComponents);
export const selectPigAccessories = createSelector(pigState, state => state.activePigAccessories);
export const selectPigAssoicatedProducts = createSelector(pigState, state => state.activePigAssociatedProducts);
export const selectBulletin = createSelector(pigState, state => state.activePigBulletin);

export const selectHasLoadedLookups = createSelector(diameters, efficiencies, purposes, services,
  (diameters, efficiencies, purposes, services) => diameters.length > 0 || efficiencies.length > 0 || purposes.length > 0 || services.length > 0);

export const selectFilterQuerystring = createSelector(selectFilter, q => {
  let str = '?';
  str += q?.previouslyPigged ? `linePreviouslyPigged=${q.previouslyPigged}&` : '';
  str += q?.pipeSizeId ? `pipeSizeId=${q.pipeSizeId}&` : '';
  str += q?.pigPurposeId ? `purposeId=${q.pigPurposeId}&` : '';
  str += q?.pipelineServiceId ? `serviceId=${q.pipelineServiceId}&` : '';
  str += q?.bidirectional ? `bidirectional=${q.bidirectional}&` : '';
  str += q?.efficiencyEffectiveness ? `efficiency=${q.efficiencyEffectiveness}&` : '';
  str += q?.aggressivenessRisk ? `aggressiveness=${q.aggressivenessRisk}&` : '';

  return str.substring(0, str.length - 1);
});

export const selectShouldCallHttpForFilter = createSelector(selectFilter, pigFilter => {
  if ((pigFilter?.previouslyPigged) === -1) return false;
  if ((pigFilter?.pipeSizeId || -1) < 0) return false;

  // if hasBeenPreviously pigged - they need to pick pipeline size && a purpose
  if (pigFilter?.previouslyPigged === 1 && !pigFilter.pigPurposeId) return false;

  return true;
});

export const selectLoaders = createSelector(pigState, pigState => pigState.loaders);
export const selectLoader = (name: fromStore.Loaders) =>
  createSelector(selectLoaders, (loaders: fromStore.Loaders[]) => !!((loaders || []).find(f => f === name)));
